import React from "react";
import UlLi, {scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import ApptokenDisplay from "js/utilities/get-display-apptoken";
import { ZOOM_ICON } from "js/config.jsx";
import SDKSidebar from "js/utilities/sdk-sidebar";

import ENCRYPTION_KEYS_SWIFT from "resources/code/ios/encryption-keys.swift.tpl";
import ENCRYPTION_KEYS_OBJC from "resources/code/ios/encryption-keys.m.tpl";
import ENCRYPTION_KEY_JAVA from "resources/code/hybrid/android/07-set-encryption-key.java.tpl";
import ENCRYPTION_KEY_JAVA_SERVER from "resources/code/ios/encryption-keys.java.tpl";
import ENCRYPTION_KEY_JS from "resources/code/ios/encryption-keys.js.tpl";
import SDK_INITIALIZE_SWIFT from "resources/code/quickstart/ios/00-initialize.swift.tpl";
import SDK_INITIALIZE_OBJC from "resources/code/quickstart/ios/00-initialize.m.tpl";
import SDK_IMPORT_SWIFT from "resources/code/quickstart/ios/01-import.swift.tpl";
import SDK_IMPORT_OBJC from "resources/code/quickstart/ios/01-import.m.tpl";
import SDK_START_ENROLLMENT_SWIFT from "resources/code/quickstart/ios/02-start-enrollment.swift.tpl";
import SDK_START_ENROLLMENT_OBJC from "resources/code/quickstart/ios/02-start-enrollment.m.tpl";
import ON_BEFORE_DISMISS_SWIFT from "resources/code/ios/37-exit-animations.swift.tpl";
import ON_BEFORE_DISMISS_OBJC from "resources/code/ios/37-exit-animations.m.tpl";


export default React.createClass({
  displayName: "session-tokens",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var data  = [
        ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data: data,
      navMenuParent: null,
      navMenu: null,
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">
              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="session-token">Session Tokens</h2>
                </div>
                <p>This guide discusses a new security feature in the FaceTec Server SDK 8.4+ and how to implement it.</p>
                <hr/>
              </section>

              <section>
                <h3 id="overview">Overview</h3>
                <p>Session Tokens are a new feature in FaceTec SDKs v8.4 and above that make FaceMaps even more tamper resistant and reduce the surface area of potential attacks.</p>
                <hr />
              </section>

              <section>
                <h3 id="technical-description">Technical Description</h3>
                <p>FaceTec Server SDK generates an encrypted, signed piece of data <strong>called a Session Token</strong>, that gets taken in as the input to the device-side User Session launch code.  The Session Token is then embedded into the 3D FaceMap and subsequently verified as a part of processing the FaceMap back on the server.  This allows enhanced verification of the validity and integrity of FaceMaps as well as the ability to configure FaceMaps to expire.</p>
                <hr />
              </section>

              <section>
                <h3 id="best-practice-recommendation">Best Practice Recommendation</h3>
                <p>FaceTec's best practice recommendation is to require Session Token validation on each request.  This means checking the result object from <code>prepareAndUpdateFaceMap</code> and ensuring that the <code>sessionTokenStatus</code> is <code>ZoomSessionTokenValid</code>.  Any other value means either a Session Token was not applied to the FaceMap or that the Session Token validation failed or was invalid.</p>
                <hr />
              </section>

              <section>
                <h3 id="enabling-session-tokens">Enabling Session Tokens</h3>
                <p>Session Token validation is enabled by default.  Developers should evaluate the <code>sessionTokenStatus</code> to decide whether to succeed, fail, or flag the Session.</p>
                <hr />
              </section>

              <section>
                <h3 id="integrating-session-tokens">Integrating Session Tokens</h3>
                <p>The Sample App on each platform demonstrates how Session Tokens are retrieved from the server and used in the platform-specifc User Session launch code.</p>
                <hr />
              </section>

              <section>
                <h3 id="configuring-session-tokens">Configuring Session Token Validation Period</h3>
                <p>Use the <code>setSessionTokenValidationPeriod</code> and set to a non-zero int representing the minutes you would like the Session Token to remain valid for.  The default is 5 minutes.  This value should be set to the smallest amount of time possible between the time you generate the Session Token to the time it is evaluated.</p>
              </section>

              <hr />

              <section>
                <h3 id="upgrading">Upgrading</h3>
                <p>When running FaceTec Server 8.4 and above, FaceMaps generated from previous versions of the Device SDK are still 100% supported.  However, the <code>sessionTokenStatus</code> will always be <code>ZoomSessionTokenNotProvided</code> since the FaceMap did not have a Session Token applied to it.  Thus, you can still support users with older versions of the Device SDK by checking for <code>ZoomSessionTokenNotProvided</code> in these cases, while requiring <code>ZoomSessionTokenValid</code> for 8.4+ versions of the Device SDKs.</p>
                <hr />
             </section>

          </div>

          <SDKSidebar menuType="main" title="Session Tokens"/>

        </div>
      </div>
    </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/session-tokens.jsx